import React, { useState } from "react";
import {
  Button,
  Flex,
  Text,
  useDisclosure,
  Icon,
  Tooltip,
} from "@chakra-ui/react";
import {
  textSecondary,
  primaryAlt,
  buttonRed,
  buttonRedText,
  buttonRedDark,
  white,
} from "../../utils/colors";
import useThemeColors from "../../hooks/useThemeColors";
import { useTranslation } from "react-i18next";
import { TbDental, TbDiscount } from "react-icons/tb";
import PriceQuantityPopoverModal from "./PriceQuantityPopoverModal";
import WarningModal from "../buttons/partials/WarningModal";
import useCurrencySymbol from "../../hooks/useCurrencySymbol";
import { useSelector } from "react-redux";
import { MdLocalHospital } from "react-icons/md";

const PriceQuantityPopover = ({
  service,
  saveEditedService,
  isQuantityZero,
  isExpanded,
  isServicePriceVariations,
  tpStatus,
  setStatus,
  resetServicesStatusToUncompleted,
  currency,
}) => {
  // GENERAL
  const { t } = useTranslation();

  // COLORS
  const { backgroundLightMode } = useThemeColors();

  // REDUX

  const tenantDetailsBySlug = useSelector((state) => state.tenantDetailsBySlug);
  const { tenant } = tenantDetailsBySlug;

  // STATES
  const currencySymbol = useCurrencySymbol(currency);

  const { isOpen, onOpen, onClose } = useDisclosure();

  const [warningModal, setWarningModal] = useState(false);
  const [warningTitle, setWarningTitle] = useState("");
  const [warningMessage, setWarningMessage] = useState("");
  const [warningButtons, setWarningButtons] = useState(false);
  const [pendingStatus, setPendingStatus] = useState("");

  // HANDLERS

  const confirmStatusChange = () => {
    saveEditedService(service);
    setWarningModal(false);
    onOpen();

    if (pendingStatus) {
      setStatus(pendingStatus);
      if (pendingStatus === "planning") {
        resetServicesStatusToUncompleted();
      }
    }
  };

  const cancelStatusChange = () => {
    setWarningModal(false);
  };

  // const handleOpen = () => {
  //   if (tpStatus === "approved") {
  //     setWarningTitle(t("treatmentPlan.approvedPlanningStatusWarningTitle"));
  //     setWarningMessage(t("service.approvedPlanningStatusWarningText"));
  //     setPendingStatus("planning");
  //     setWarningModal(true);
  //   } else {
  //     onOpen();
  //   }
  // };
  // const handleOpen = () => {
  //   if (tpStatus !== "planning") {
  //     setWarningTitle(t("warnings.editServiceStatusWarningTitle"));
  //     setWarningMessage(t("warnings.editServiceStatusWarningMessage"));
  //     setPendingStatus("planning");
  //     setWarningModal(true);
  //     setWarningButtons(true);
  //   } else {
  //     onOpen();
  //   }
  // };

  const handleOpen = () => {
    if (tpStatus === "planning") {
      onOpen();
    } else if (tpStatus === "ongoing") {
      setWarningTitle(t("warnings.editServiceStatusWarningTitle"));
      setWarningMessage(t("warnings.editServiceOngoingStatusWarningMessage"));
      setPendingStatus("planning");
      setWarningModal(true);
      setWarningButtons(true);
    } else {
      setWarningTitle(t("warnings.editServiceStatusWarningTitle"));
      setWarningMessage(t("warnings.editServiceStatusWarningMessage"));
      setPendingStatus("planning");
      setWarningModal(true);
      setWarningButtons(true);
    }
  };

  const handleClose = () => {
    onClose();
  };

  // QUANTITY

  // DISCOUNT

  // LOGS
  // console.log(
  //   "isServicePriceVariations in PriceQuantityPopover:",
  //   isServicePriceVariations
  // );

  // console.log("tpStatus in PriceQuantityPopover:", tpStatus);

  // console.log("service in PriceQuantityPopover:", service);

  return (
    <>
      {warningModal && (
        <WarningModal
          open={warningModal}
          setOpen={setWarningModal}
          warningTitle={warningTitle}
          warningMessage={warningMessage}
          warningButtons={warningButtons}
          statusBefore={tpStatus}
          statusAfter={pendingStatus}
          confirmHandler={confirmStatusChange}
          cancelHandler={cancelStatusChange}
          pendingStatus={pendingStatus}
        />
      )}

      {isOpen && (
        <PriceQuantityPopoverModal
          isOpen={isOpen}
          handleOpen={handleOpen}
          handleClose={handleClose}
          service={service}
          saveEditedService={saveEditedService}
          isPriceVariations={isServicePriceVariations}
          currency={currency}
          tenant={tenant}
        />
      )}

      <Tooltip
        p="0.5rem 0.5rem"
        borderRadius="1rem"
        // label={
        //   isServicePriceVariations
        //     ? t("service.pleaseSelectTeeth")
        //     : t("service.pleaseSelectQuantity")
        // }
        label={
          <Flex direction="column" align="center" justify="center">
            {tpStatus === "cancelled" ? (
              <Flex direction="column">
                <Text fontSize="xs" fontWeight="500" textAlign="center">
                  {t("warnings.tooltipCancelledChangePriceQuantityText")}
                </Text>
                {service && service.discountValue > 0 && (
                  <>
                    <Flex w="100%" direction="column" m="1rem 0 0">
                      <Text fontSize="xs" fontWeight="500" textAlign="center">
                        {t("service.discount")}:
                      </Text>

                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          textDecoration="line-through"
                        >
                          {currencySymbol} {service.price}
                        </Text>

                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          mx="1.5rem"
                          color={buttonRedText}
                        >
                          {currencySymbol} {service.discountValue}
                        </Text>

                        <Text fontSize="xs" fontWeight="500" textAlign="center">
                          {currencySymbol} {service.discountedPrice}
                        </Text>
                      </Flex>
                    </Flex>
                  </>
                )}
              </Flex>
            ) : tpStatus === "approved" ? (
              <Flex direction="column">
                <Text fontSize="xs" fontWeight="500" textAlign="center">
                  {t("warnings.tooltipOnlyPlanningChangePriceQuantityText")}
                </Text>

                {service && service.discountValue > 0 && (
                  <>
                    <Flex w="100%" direction="column" m="1rem 0 0">
                      <Text fontSize="xs" fontWeight="500" textAlign="center">
                        {t("service.discount")}:
                      </Text>

                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          textDecoration="line-through"
                        >
                          {currencySymbol} {service.price}
                        </Text>

                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          mx="1.5rem"
                          color={buttonRedText}
                        >
                          {currencySymbol} {service.discountValue}
                        </Text>

                        <Text fontSize="xs" fontWeight="500" textAlign="center">
                          {currencySymbol} {service.discountedPrice}
                        </Text>
                      </Flex>
                    </Flex>
                  </>
                )}
              </Flex>
            ) : tpStatus === "ongoing" ? (
              <Flex direction="column">
                <Text fontSize="xs" fontWeight="500" textAlign="center">
                  {t(
                    "warnings.tooltipOngoingOnlyPlanningChangePriceQuantityText"
                  )}
                </Text>

                {service && service.discountValue > 0 && (
                  <>
                    <Flex w="100%" direction="column" m="1rem 0 0">
                      <Text fontSize="xs" fontWeight="500" textAlign="center">
                        {t("service.discount")}:
                      </Text>

                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          textDecoration="line-through"
                        >
                          {currencySymbol} {service.price}
                        </Text>

                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          mx="1.5rem"
                          color={buttonRedText}
                        >
                          {currencySymbol} {service.discountValue}
                        </Text>

                        <Text fontSize="xs" fontWeight="500" textAlign="center">
                          {currencySymbol} {service.discountedPrice}
                        </Text>
                      </Flex>
                    </Flex>
                  </>
                )}
              </Flex>
            ) : tpStatus === "completed" ? (
              <Flex direction="column">
                <Text fontSize="xs" fontWeight="500" textAlign="center">
                  {t("warnings.tooltipCompletedChangePriceQuantityText")}
                </Text>

                {service && service.discountValue > 0 && (
                  <>
                    <Flex w="100%" direction="column" m="1rem 0 0">
                      <Text fontSize="xs" fontWeight="500" textAlign="center">
                        {t("service.discount")}:
                      </Text>

                      <Flex align="center" justify="center">
                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          textDecoration="line-through"
                        >
                          {currencySymbol} {service.price}
                        </Text>

                        <Text
                          fontSize="xs"
                          fontWeight="500"
                          textAlign="center"
                          mx="1.5rem"
                          color={buttonRedText}
                        >
                          {currencySymbol} {service.discountValue}
                        </Text>

                        <Text fontSize="xs" fontWeight="500" textAlign="center">
                          {currencySymbol} {service.discountedPrice}
                        </Text>
                      </Flex>
                    </Flex>
                  </>
                )}
              </Flex>
            ) : (
              <Text fontSize="xs" fontWeight="500" textAlign="center">
                {t("service.pleaseSelectQuantity")}
              </Text>
            )}
          </Flex>
        }
        placement="top"
        // isOpen={isQuantityZero}
        isDisabled={isExpanded || isQuantityZero}
        // onClick={(e) => e.stopPropagation()}
      >
        <Button
          minW="180px"
          maxW="180px"
          size="md"
          h={["2rem", "2.25rem"]}
          bg={isQuantityZero ? buttonRed : backgroundLightMode}
          borderRadius="100rem"
          align="center"
          justify="flex-end"
          gap="0.5rem"
          onClick={(e) => {
            e.stopPropagation();
            handleOpen();
          }}
          cursor="pointer"
          role="group"
          _hover={{
            bg: isQuantityZero ? buttonRedDark : backgroundLightMode,
          }}
          isDisabled={
            tpStatus === "cancelled" ||
            tpStatus === "completed" ||
            tpStatus === "approved" ||
            tpStatus === "ongoing"
          }
        >
          {!isQuantityZero ? (
            <Flex align="center" justify="space-between" w="100%">
              <Flex align="center" position="relative">
                <Flex align="center" justify="center" mr="0.25rem" w="20px">
                  {isServicePriceVariations ? (
                    <Icon
                      as={TbDental}
                      color={textSecondary}
                      position="relative"
                      top="-1px"
                      fontSize="0.875rem"
                    />
                  ) : (
                    <Text fontSize="xs" fontWeight="500" color={textSecondary}>
                      {t("common.qty")}
                    </Text>
                  )}
                </Flex>

                {isServicePriceVariations ? (
                  <Text
                    fontSize="sm"
                    fontWeight="500"
                    color={textSecondary}
                    minW="1rem"
                    maxW="1rem"
                    w="100%"
                    textAlign="right"
                  >
                    {service && service.teeth && service.teeth.length > 0
                      ? service.teeth.length
                      : "-"}
                  </Text>
                ) : (
                  <Text
                    fontSize="sm"
                    fontWeight="500"
                    color={textSecondary}
                    minW="1rem"
                    maxW="1rem"
                    w="100%"
                    textAlign="right"
                  >
                    {service.quantity}
                  </Text>
                )}
              </Flex>

              <Flex align="center">
                <Text
                  fontSize="xs"
                  fontWeight="400"
                  color={textSecondary}
                  px="1rem"
                >
                  |
                </Text>
              </Flex>

              <Flex
                align="center"
                justify="flex-end"
                w="100%"
                minW="60px"
                maxW="60px"
              >
                {service.discountValue > 0 && (
                  <Flex align="center" justify="center" textAlign="center">
                    <Icon
                      as={TbDiscount}
                      color={primaryAlt}
                      fontSize="0.875rem"
                      mr="0.125rem"
                      position="relative"
                      top="-1px"
                    />
                  </Flex>
                )}

                {service.reimbursement &&
                  service.reimbursement.coverage > 0 && (
                    <Flex align="center" justify="center" textAlign="center">
                      <Icon
                        as={MdLocalHospital}
                        color={primaryAlt}
                        fontSize="0.875rem"
                        mr="0.125rem"
                        position="relative"
                        top="-1px"
                      />
                    </Flex>
                  )}

                <Text
                  fontSize="sm"
                  fontWeight="500"
                  color={textSecondary}
                  // color={discount > 0 ? primaryAlt : textSecondary}

                  // w="100%"
                  textAlign="right"
                >
                  {service && service.totalPrice
                    ? `${currencySymbol} ${service.totalPrice.toFixed(0)}`
                    : "-"}
                </Text>
              </Flex>
            </Flex>
          ) : (
            <Flex align="center" justify="center" w="100%">
              <Text
                fontSize="0.8rem"
                fontWeight="600"
                color={buttonRedText}
                textAlign="center"
                _groupHover={{ color: white }}
              >
                {t("service.pleaseSelectTeeth")}
              </Text>
            </Flex>
          )}
        </Button>
      </Tooltip>
    </>
  );
};

export default PriceQuantityPopover;
